import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { Input } from '../Input/index.js';
import { ClearIcon, ClearableInputContainer, IconButton } from './styles.js';
const DatePickerInput = forwardRef(function DatePickerInput({ onClearClick, isClearable, dateSelected, ...restProps }, ref) {
    if (isClearable) {
        return (_jsxs(ClearableInputContainer, { children: [_jsx(Input, { ref: ref, ...restProps, clearButton: true }), dateSelected && (_jsx(IconButton, { onClick: onClearClick, children: _jsx(ClearIcon, { size: 10 }) }))] }));
    }
    return _jsx(Input, { ...restProps });
});
export default memo(DatePickerInput);
